import { Call } from '@twilio/voice-sdk';

const InProgress: readonly string[] = [
	Call.State.Connecting,
	Call.State.Open,
	Call.State.Reconnecting,
	Call.State.Ringing,
];

/**
 * Whether a newer inbound leg would be taking over from a call in progress. Excludes an
 * unanswered leg (`Pending`), which a newer one is allowed to supersede.
 */
export function isLiveCall(call: Call | undefined): boolean {
	return !!call && InProgress.includes(call.status());
}
